export default __webpack_public_path__ + "static/media/pm-logo.5c4ceeeb.png";